<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-form class="toolbar" :inline="true" size="mini">
      <el-form-item label="关键字">
        <el-input v-model="params.keyword" placeholder="请输入关键字" clearable></el-input>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="params.d1"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="params.d2"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间">
        </el-date-picker>
      </el-form-item>

      <el-button type="primary" @click="listSearch" size="mini">查询</el-button>
      <el-button type="success" @click="addCompany" size="mini">新增</el-button>
    </el-form>
    <paging :url="url.list" :params="params" ref="paging" style="width: 990px;">
      <el-table border slot-scope="grid" :data="grid.data" style="width: 100%;" height="500px" v-loading="grid.loading || loading">
        <el-table-column align="center" prop="F_CanNo" label="车号" width="100">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row,false)" type="text" size="small">{{scope.row.F_No}}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="F_CompanyName" label="运输公司" width="120"></el-table-column>
        <el-table-column align="center" prop="F_Weight" label="牵引总质量" width="100"></el-table-column>
        <el-table-column align="center" prop="F_CurbWeight" label="整备质量" width="100"></el-table-column>
        <el-table-column align="center" prop="F_EmissionStandard" label="排放标准" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.F_EmissionStandard == 3" type="success">国Ⅲ</el-tag>
            <el-tag v-if="scope.row.F_EmissionStandard == 4" type="danger">国Ⅳ</el-tag>
            <el-tag v-if="scope.row.F_EmissionStandard == 5" type="info">国Ⅴ</el-tag>
            <el-tag v-if="scope.row.F_EmissionStandard == 6" type="warning">国Ⅵ</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="F_DrivingLicenseNo" label="行驶证编号" width="120"></el-table-column>
        <el-table-column align="center" prop="F_DrivingLicenseValidateDate" label="行驶证有效期" width="160"></el-table-column>
        <el-table-column align="center" prop="F_RoadTransCode" label="道路运输证号" width="120"></el-table-column>
        <el-table-column align="center" prop="F_RoadTransValidateDate" label="道路运输证有效期" width="160"></el-table-column>
        <el-table-column fixed="right" label="操作" width="220" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row,true)" type="text" size="small">编辑</el-button>
            <el-button @click="onDelete(scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="onPhone(scope.row)" type="text" size="small">关联手机号</el-button>
          </template>
        </el-table-column>
      </el-table>
    </paging>

    <!--修改弹框-->
    <dialog-form title="牵引车"
                 :formTemplate="formTemplate"
                 :visible.sync="visible"
                 :form="form" :rules="rules"
                 :url="url.save"
                 :isEdit="isEdit"
                 :canEdit="canEdit"
                 :labelPosition="labelPosition"
                 :labelWidth="labelWidth"
                 @beforeSave="beforeSave"
                 @saved="editSave()"
                  @onSavedError="onSavedError">
    </dialog-form>

    <el-dialog :close-on-click-modal="false" center title="关联手机号" :visible.sync="dialogTablePhone">
      <el-button @click="" type="text" size="small"></el-button>
      <el-table :data="Phones" border>
        <el-table-column header-align="center" align="center" property="F_TelNo" label="手机号"></el-table-column>
        <el-table-column header-align="center" align="center" property="F_CreateTime" label="创建时间"></el-table-column>
        <el-table-column header-align="center" align="center" property="F_Creator" label="操作人"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="onDeletePhone(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="addPhone">新增关联手机号</el-button>
        <el-button type="primary" @click="dialogTablePhone = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
  import Paging from '@/components/Table/Paging'
  import DialogForm from '@/components/Dialogs/DialogForm';

  export default {
    components: {
      Paging, DialogForm
    },
    props: {
      screen: {
        type: Object,
        default: () => {
        }
      },
    },
    data() {
      let validateCarNo = (rule, value, callback) => {
        let regex = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领台A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
        if (value != null && !regex.test(value)) {
          callback(new Error('请输入正确的车牌号'));
        } else {
          callback();
        }
      }
      return {
        labelWidth:'160px',
        labelPosition:'right',
        url: {
          list: SZH.assets.api + '/WHPTruck/GetGridJson',
          save: SZH.assets.api + '/WHPTruck/SumbitForm',
          delete: SZH.assets.api + '/WHPTruck/DeleteForm',
          get: SZH.assets.api + '/WHPTruck/GetFormJson',
          GetGridJsonLinkUser: SZH.assets.api + '/WHPDriver/GetGridJsonLinkUser',
          InsertLinkTelUser: SZH.assets.api + '/WHPDriver/InsertLinkTelUser',
          DeleteLinkTelUser: SZH.assets.api + '/WHPDriver/DeleteLinkTelUser',
          companySelect: SZH.assets.api + '/WHPTransCompany/GetAllJson',
          GetList: SZH.assets.api + '/WHPTruckCan/GetList',
        },
        loading: false,
        fullscreenLoading: false,
        params: {
          keyword:'',
          d1:'',
          d2:''
        },
        visible: false,
        form: {
          F_Id: '',
          F_No: '',
          F_CanNo:'',//挂车
          F_CompanyName: '',//所属运输公司
          F_DrivingLicenseNo: '',//行驶证编号
          F_DrivingLicenseValidateDate: '',//行驶证有效期
          F_RoadNo: '',//道路运输证号
          F_RoadTransValidateDate: '',//道路运输证有效期
          F_Weight: '',//牵引总质量
          F_CurbWeight: '',//整备质量
          F_EmissionStandard: '',//排放标准(3:国Ⅲ，4:国Ⅳ,5国Ⅴ,6:国Ⅵ)
          F_TransCompanyNo: '',//所属运输公司Id


          F_RoadTransImgUrl:'',//车辆道路运输证照片正面
          F_RoadTransImgUrl2:'',//车辆道路运输证照片反面
          F_DriveringImgUrl1:'',//行驶证正面
          F_DriveringImgUrl2:'',//行驶证反面
          F_SpecialEquipmentImgUrl:'',//特种设备使用登记证
          F_RoadTransImgUrlBefore:[],
          F_RoadTransImgUrl2Before:[],
          F_DriveringImgUrl1Before:[],
          F_DriveringImgUrl2Before:[],
          F_RoadTransImgBase64On:'',
          F_RoadTransImgBase64Off:'',
          F_DriveringImgBase64On:'',
          F_DriveringImgBase64Off:'',
        },
        isEdit:false,
        formTemplate: [
          {col: 12, label: '车号', prop: 'F_No'},
          {col: 12, label: '挂车号', prop: 'F_CanNo',type: "select",options: [],filterable: true,default: null,change: (v) => {},},
          {col: 12, label: '运输公司', prop: 'F_TransCompanyNo',type: "select",options: [],filterable: true,default: null,change: (v) => {},},
          {col: 12, label: '行驶证编号', prop: 'F_DrivingLicenseNo'},
          {col: 12, label: '行驶证有效期', prop: 'F_DrivingLicenseValidateDate',type: "date"},
          {col: 12, label: '道路运输证号', prop: 'F_RoadNo'},
          {col: 12, label: '道路运输证有效期', prop: 'F_RoadTransValidateDate',type: "date"},
          {col: 12, label: '牵引总质量', prop: 'F_Weight',type: "number"},
          {col: 12, label: '整备质量', prop: 'F_CurbWeight',type: "number"},
          {col: 12, label: '排放标准', prop: 'F_EmissionStandard',type: "select",options: [{label:'国Ⅲ',value:3},{label:'国Ⅳ',value:4},{label:'国Ⅴ',value:5},{label:'国Ⅵ',value:6}],filterable: true,default: null,change: (v) => {},},
          {col: 12, label: '道路运输证照片正面', prop: 'F_RoadTransImgUrlBefore',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '道路运输证照片反面', prop: 'F_RoadTransImgUrl2Before',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '行驶证正面', prop: 'F_DriveringImgUrl1Before',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '行驶证反面', prop: 'F_DriveringImgUrl2Before',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
        ],
        rules: {
          F_No: [
            {required: true, message: '请输入车号', trigger: 'blur'},
          ],
          F_CanNo: [
            {required: true, message: '请选择挂车', trigger: 'change'},
          ],
          F_TransCompanyNo: [
            {required: true, message: '请选择运输公司', trigger: 'change'},
          ],
          F_DrivingLicenseNo: [
            {required: true, message: '请输入行驶证编号', trigger: 'blur'},
          ],
          F_DrivingLicenseValidateDate: [
            {required: true, message: '请选择行驶证有效期', trigger: 'change'},
          ],
          F_RoadNo: [
            {required: true, message: '请输入道路运输证号', trigger: 'blur'},
          ],
          F_RoadTransValidateDate: [
            {required: true, message: '请选择道路运输证有效期', trigger: 'change'},
          ],
          F_Weight: [
            {required: true, message: '请输入牵引总质量', trigger: 'blur'},
          ],
          F_CurbWeight: [
            {required: true, message: '请输入整备质量', trigger: 'blur'},
          ],
          F_EmissionStandard: [
            {required: true, message: '请选择排放标准', trigger: 'change'},
          ],

          F_RoadTransImgUrlBefore: [
            {required: true, message: '请选择道路运输证照片正面', trigger: 'blur'},
          ],
          F_RoadTransImgUrl2Before: [
            {required: true, message: '请选择道路运输证照片反面', trigger: 'blur'},
          ],

          F_DriveringImgUrl1Before: [
            {required: true, message: '请选择行驶证正面', trigger: 'blur'},
          ],
          F_DriveringImgUrl2Before: [
            {required: true, message: '请选择行驶证反面', trigger: 'blur'},
          ],
        },
        canEdit:false,
        dialogTablePhone:false,
        Phones:[],
        row:'',
        companys:[],
        CanNos:[],
      }
    },
    methods: {

      onPhone(row){
        let self = this;
        self.dialogTablePhone = true;
        self.getPhones(row);
      },
      getPhones(row){
        let self = this;
        self.row = row;
        self.fullscreenLoading = true;
        self.$http.post(self.url.GetGridJsonLinkUser, {
          Data:{
            keyValue: row.F_Id
          },
          PageIndex:1,
          PageSize:200
        }).then(result => {
          if (result.state == true) {
            self.Phones = result.data.Data
          } else {
            self.Phones = [];
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
      addPhone(){
        let self = this;
        self.$prompt('请输入手机号', '新增手机号', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^((13|14|15|17|18|19|16|11|12)[0-9]{9})?$/,
          inputErrorMessage: '手机号格式不正确',
          closeOnClickModal:false,
          center: true
        }).then(({ value }) => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.InsertLinkTelUser, {
            F_TelNo:value,
            F_Type:3,
            F_ObjectId:self.row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$message.success('操作成功');
              self.getPhones(self.row);
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {

        });
      },
      onDeletePhone(row){
        var self = this;
        self.$confirm(`将手机号${row.F_TelNo}删除, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.DeleteLinkTelUser, {
            keyValue: row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$message.success('删除成功!');
              self.getPhones(self.row);
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      addCompany(){
        let self = this;
        self.visible = true;
        self.canEdit = true;
        self.form.F_RoadTransImgUrlBefore = [];
        self.form.F_RoadTransImgUrl2Before = [];
        self.form.F_DriveringImgUrl1Before = [];
        self.form.F_DriveringImgUrl2Before = [];
      },
      listSearch() {
        this.$refs['paging'].reload();
      },
      beforeSave(){
        let self = this;
        self.form.F_RoadTransImgUrl = self.form.F_RoadTransImgUrlBefore[0].path;
        self.form.F_RoadTransImgUrl2 = self.form.F_RoadTransImgUrl2Before[0].path;
        self.form.F_DriveringImgUrl1 = self.form.F_DriveringImgUrl1Before[0].path;
        self.form.F_DriveringImgUrl2 = self.form.F_DriveringImgUrl2Before[0].path;
      },
      // 保存
      editSave() {
        this.$message.success('保存成功');
        this.$refs['paging'].reload();
      },
      onSavedError(){
      },
      onEdit(row,flag){
        let self = this;
        const loading = self.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        self.visible = true;
        self.form.F_RoadTransImgUrlBefore = [];
        self.form.F_RoadTransImgUrl2Before = [];
        self.form.F_DriveringImgUrl1Before = [];
        self.form.F_DriveringImgUrl2Before = [];
        self.canEdit = flag;
        self.$http.post(self.url.get, {
          keyValue: row.F_Id
        }).then(result => {
          if (result.state == true) {
            self.$nextTick(()=>{
              for(let i in self.form){
                for(let k in result.data){
                  if(i == k){
                    self.form[i] = result.data[k];
                  }
                }
                if(i == 'F_RoadTransImgBase64On'){
                  let obj = {
                    path:result.data.F_RoadTransImgUrl,
                    Url:result.data.F_RoadTransImgBase64On
                  };
                  self.form.F_RoadTransImgUrlBefore.push(obj);
                }
                if(i == 'F_RoadTransImgBase64Off'){
                  let obj = {
                    path:result.data.F_RoadTransImgUrl2,
                    Url:result.data.F_RoadTransImgBase64Off
                  };
                  self.form.F_RoadTransImgUrl2Before.push(obj);
                }
                if(i == 'F_DriveringImgBase64On'){
                  let obj = {
                    path:result.data.F_DriveringImgUrl1,
                    Url:result.data.F_DriveringImgBase64On
                  };
                  self.form.F_DriveringImgUrl1Before.push(obj);
                }
                if(i == 'F_DriveringImgBase64Off'){
                  let obj = {
                    path:result.data.F_DriveringImgUrl2,
                    Url:result.data.F_DriveringImgBase64Off
                  };
                  self.form.F_DriveringImgUrl2Before.push(obj);
                }
              }
            });
          } else {

          }
          loading.close();
        }, () => {
          loading.close();
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },

      onDelete(row) {
        var self = this;
        self.$confirm(`将${row.F_No}删除, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.delete, {
            keyValue: row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$refs['paging'].loadData();
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      GetCompany() {
        var self = this;
        self.$http.post(self.url.companySelect, {

        }).then(result => {
          if (result.state == true) {
            self.companys = result.data;
            for(var i in self.formTemplate){
              if(self.formTemplate[i].prop == 'F_TransCompanyNo'){
                self.formTemplate[i].options =  self.companys;
              }
            }
          } else {
            self.companys = [];
            for(var i in self.formTemplate){
              if(self.formTemplate[i].prop == 'F_TransCompanyNo'){
                self.formTemplate[i].options =  self.companys;
              }
            }
          }
        }, () => {
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
      GetCarNo() {
        var self = this;
        self.$http.post(self.url.GetList, {

        }).then(result => {
          if (result.state == true) {
            self.CanNos = result.data;
            for(var i in self.formTemplate){
              if(self.formTemplate[i].prop == 'F_CanNo'){
                self.formTemplate[i].options =  self.CanNos;
              }
            }
          } else {
            self.CanNos = [];
            for(var i in self.formTemplate){
              if(self.formTemplate[i].prop == 'F_CanNo'){
                self.formTemplate[i].options =  self.CanNos;
              }
            }
          }
        }, () => {
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
    },
    computed: {},
    created() {
    },
    mounted() {
      this.GetCompany();
      this.GetCarNo();
    },
    watch: {}

  }
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Me/HazardousChemicalsEntry/Tractor/Tractor.vue